import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/dist/photoswipe.css';

if ($('.gallery')[0]) {
	document.addEventListener('DOMContentLoaded', function () {
		const lightbox = new PhotoSwipeLightbox({
			gallery: '.gallery__wrap',
			children: 'a',
			pswpModule: () => import('photoswipe')
		});

		lightbox.init();
	});
}
